import React, { Component, Fragment } from 'react';
import {
    Input,
    Button,
    Row,
    Col,
} from 'reactstrap';
import './Notes.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import ConfirmButton from '../Modal/ConfirmButton';
import { Prompt } from 'react-router-dom';

class EditContactsNote extends Component {

    constructor(props) {
        super(props);
        this.state = {
            displayCategories: this.props.displayCategories,
            date: String(this.props.row.date).substring(0, 10).replace(/(\d+)\/(\d+)\/(\d+)/, '$1-$2-$3'),
            typeID: this.props.row.typeID,
            notes: this.props.row.notes,
            unsavedChanges: false,
        };
    }

    render() {

        return (<>
            <Prompt
                when={this.state.unsavedChanges}
                message="You have unsaved changes, are you sure you want to leave?"
            />
            <Row>
                <Col className='pr-2'>
                    <Input
                        type="date"
                        name="date"
                        value={this.state.date}
                        onChange={(e) => this.setState({ date: e.target.value, unsavedChanges: true })}
                    />
                </Col>
                <Col className='pl-0'>
                    {this.props.addCategorySubCommentsArray?.map(row => {
                        switch (row.validation) {
                            case "list":
                                return (
                                    <Fragment key={row.ID}>
                                        <Input type="select"
                                            name="typeID"
                                            value={this.state.typeID}
                                            onChange={(e) => this.setState({ typeID: parseInt(e.target.value), unsavedChanges: true })}
                                        >
                                            <option value="0">ACTIVITY</option>
                                            {row.list != null && row.list
                                                .filter(item => item.longDescription !== 'Other')
                                                .map(item => (
                                                    <option key={item.ID} value={item.ID}>{item.longDescription}</option>
                                                ))}
                                        </Input>
                                    </Fragment>
                                )
                            default:
                                return (
                                    <></>
                                )
                        }
                    })}
                </Col>
            </Row>
            <Row className='mt-2'>
                <Col>
                    <Input
                        type="textarea"
                        name="notes"
                        rows={15}
                        value={this.state.notes}
                        onChange={(e) => this.setState({ notes: e.target.value, unsavedChanges: true })}
                    />
                </Col>
            </Row>
            <Row className='mt-2'>
                <Col>
                    <Button
                        disabled={this.state.notes === ''}
                        className="mx-1"
                        color="success"
                        onClick={() => this.setState({ unsavedChanges: false},() => { this.props.editNote(this.props.row.id, this.state.date, this.state.typeID, this.state.notes)})}
                        title="Edit Note"
                    >
                        <FontAwesomeIcon icon={faCheck} />
                    </Button>
                    <ConfirmButton
                        className='mx-2'
                        color="danger"
                        onClick={() => this.setState({ unsavedChanges: false}, () => {this.props.deleteNote(this.props.row.id)})}
                        title="Delete Note"
                    ><FontAwesomeIcon icon={faTrashAlt} />
                    </ConfirmButton>
                    <Button
                        className="mx-1"
                        color="secondary"
                        onClick={() => this.setState({ unsavedChanges: false}, () => { this.props.handleEditSwap(0)})}
                        title="Cancel">
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </Col>
            </Row></>
        )
    }
}

export default EditContactsNote;
